module.exports = __webpack_public_path__ + "img/porta-tancada.0363e035.png";